import snakeCase from "just-snake-case";

type val<T> = T | T[];
export type value = val<string | number | boolean | null | undefined>;
type obj = Record<string, value>;
export type Obj = Record<string, value | val<obj>>;

export const snake = <T, TReturn>(
  obj: Obj | value | unknown,
  props?: (keyof T)[],
  renameProps: (keyof TReturn | undefined)[] = []
): TReturn => snakelize(obj, props, renameProps) as TReturn;

// transform a object to snakeCase
const snakelize = <T = Record<string, unknown>, TReturn = unknown>(
  obj: Obj | value | unknown,
  props?: (keyof T)[],
  renameProps: (keyof TReturn | undefined)[] = []
): TReturn | Obj | value => {
  if (Array.isArray(obj)) {
    return obj.map((val) => {
      if (["string", "number", "boolean", "function", "undefined"].includes(typeof val) || val === null) {
        return val;
      } else {
        // isArray or object
        return snakelize(val as Obj | value);
      }
    }) as value;
  } else {
    return ((props !== undefined && props.length > 0 ? props : Object.keys(obj as Obj)) as string[]).reduce(
      (acu, key, index) => {
        if (
          ["string", "number", "boolean", "function", "undefined"].includes(typeof (obj as Obj)[key]) ||
          (obj as Obj)[key] === null
        ) {
          return {
            ...acu,
            [(renameProps[index] !== undefined ? renameProps[index] : snakeCase(key)) as string]: (
              obj as Obj
            )[key],
          };
        } else {
          // isArray or object
          return {
            ...acu,
            [(renameProps[index] !== undefined ? renameProps[index] : snakeCase(key)) as string]: snakelize(
              (obj as Obj)[key] as Obj | value
            ),
          };
        }
      },
      {}
    );
  }
};

export default snakelize;
